// Theme Loader - Loads saved theme from localStorage on app startup

export const loadSavedTheme = () => {
  try {
    const savedTheme = localStorage.getItem('siteTheme');
    
    if (savedTheme) {
      const theme = JSON.parse(savedTheme);
      applyTheme(theme.primary, theme.secondary, theme.accent);
      console.log('Theme loaded:', theme.name || 'Custom');
    }
  } catch (error) {
    console.error('Error loading theme:', error);
  }
};

const lightenColor = (color, percent) => {
  const num = parseInt(color.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = (num >> 8 & 0x00FF) + amt;
  const B = (num & 0x0000FF) + amt;
  return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
    (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
    (B < 255 ? B < 1 ? 0 : B : 255))
    .toString(16).slice(1);
};

const applyTheme = (primary, secondary, accent) => {
  const root = document.documentElement;
  
  // Calculate light versions
  const lightColor = lightenColor(primary, 85);
  const veryLightColor = lightenColor(primary, 95);
  
  // Convert hex to RGB for rgba usage
  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : null;
  };
  
  const primaryRgb = hexToRgb(primary);
  const secondaryRgb = hexToRgb(secondary);
  const accentRgb = hexToRgb(accent);
  
  // Apply CSS variables
  root.style.setProperty('--primary-red', primary);
  root.style.setProperty('--secondary-red', secondary);
  root.style.setProperty('--accent-red', accent);
  root.style.setProperty('--light-red', lightColor);
  root.style.setProperty('--very-light-red', veryLightColor);
  
  // Set RGB values for rgba usage
  root.style.setProperty('--primary-red-rgb', primaryRgb);
  root.style.setProperty('--secondary-red-rgb', secondaryRgb);
  root.style.setProperty('--accent-red-rgb', accentRgb);
  
  // Also update blue and gold variables (they're aliased to red now)
  root.style.setProperty('--primary-blue', primary);
  root.style.setProperty('--secondary-blue', secondary);
  root.style.setProperty('--accent-blue', accent);
  root.style.setProperty('--light-blue', lightColor);
  root.style.setProperty('--very-light-blue', veryLightColor);
  root.style.setProperty('--primary-gold', primary);
  root.style.setProperty('--secondary-gold', secondary);
  root.style.setProperty('--light-gold', lightColor);
};
